import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { login, getCountries } from './loginActions';
import LoginForm from './LoginForm';
import Login from './Login';

class LoginContainer extends Component {
  componentDidMount() {
    this.props.getCountries();
    document.body.classList.remove('modal-open');
  }

  handleSubmit = (values) => {
    this.props.login(values);
  };

  containsFooter = () =>
    this.props.countries.some(
      (country) =>
        country.access === '2' &&
        country.emailCustomerService !== null &&
        this.props.intl.locale === country.language,
    );

  render() {
    return (
      <Login footer={this.containsFooter()} entering={this.props.entering}>
        <LoginForm
          onSubmit={this.handleSubmit}
          countries={this.props.countries}
          error={this.props.error}
        />
      </Login>
    );
  }
}

LoginContainer.propTypes = {
  login: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = ({ login }) => ({ ...login });

export default compose(
  connect(mapStateToProps, { login, getCountries }),
  injectIntl,
)(LoginContainer);
